import React from "react";
import { IColum } from "../../../../../utils/copyToClipboardInXlsFormat";
import { IntlFormatUSD } from "../../../../../utils";
import { CENTS_IN_DOLLAR } from "../../../../../constants";

export const PURCHASES_TO_TOOK_EVALUATION_COLUMNS: Array<IColum> = [
  {
    by: "account.id",
    title: "Account ID",
    path: "account.id",
    isSortable: true,
  },
  {
    by: "account.email",
    title: "Email",
    path: "account.email",
    isSortable: true,
  },
  {
    by: "account.name",
    title: "Name",
    path: "account.name",
    isSortable: true,
  },
  {
    by: "total_price",
    title: "Sum of sales",
    path: "total_price",
    isSortable: true,
    //@ts-ignore
    getCellValue: (total_amount: number): React.ReactElement => {
      return <span>{IntlFormatUSD(total_amount / CENTS_IN_DOLLAR)}</span>;
    },
    //@ts-ignore
    copyToClipBoardCallBack: (total_amount: number): string => {
      return IntlFormatUSD(total_amount / CENTS_IN_DOLLAR);
    },
  },
  {
    by: "subscription_sum",
    title: "Subscription",
    path: "subscription_sum",
    isSortable: true,
    //@ts-ignore
    getCellValue: (subscription_sum: number, rest: ISpentToPassEvaluation): React.ReactElement => {
      return (
        <span>
          ({rest.subscription_count}){IntlFormatUSD(subscription_sum / CENTS_IN_DOLLAR)}
        </span>
      );
    },
    //@ts-ignore
    copyToClipBoardCallBack: (subscription_sum: number, rest: ISpentToPassEvaluation): string => {
      return `(${rest.subscription_count})${IntlFormatUSD(subscription_sum / CENTS_IN_DOLLAR)}`;
    },
  },
  {
    by: "rebill_sum",
    title: "Rebill",
    path: "rebil_count",
    isSortable: true,
    //@ts-ignore
    getCellValue: (rebil_count: number, rest: ISpentToPassEvaluation): React.ReactElement => {
      return (
        <span>
          ({rebil_count}) {IntlFormatUSD(rest.rebill_sum / CENTS_IN_DOLLAR)}
        </span>
      );
    },
    //@ts-ignore
    copyToClipBoardCallBack: (rebil_count: number, rest: ISpentToPassEvaluation): string => {
      return `(${rebil_count}) ${IntlFormatUSD(rest.rebill_sum / CENTS_IN_DOLLAR)}`;
    },
  },
  {
    by: "paid_reset_sum",
    title: "Resets",
    path: "paid_reset_count",
    isSortable: true,
    //@ts-ignore
    getCellValue: (paid_reset_count: number, rest: ISpentToPassEvaluation): React.ReactElement => {
      return (
        <span>
          ({paid_reset_count}) {IntlFormatUSD(rest.paid_reset_sum / CENTS_IN_DOLLAR)}
        </span>
      );
    },
    //@ts-ignore
    copyToClipBoardCallBack: (paid_reset_count: number, rest: ISpentToPassEvaluation): string => {
      return `(${paid_reset_count}) ${IntlFormatUSD(rest.paid_reset_sum / CENTS_IN_DOLLAR)}`;
    },
  },
  {
    by: "",
    title: "Unit Sold",
    path: "paid_reset_count",
    //@ts-ignore
    getCellValue: (_: number, rest: ISpentToPassEvaluation): React.ReactElement => {
      return <span>{rest.paid_reset_count + rest.subscription_count + rest.rebil_count}</span>;
    },
    //@ts-ignore
    copyToClipBoardCallBack: (_: number, rest: ISpentToPassEvaluation): string => {
      return `${rest.paid_reset_count + rest.subscription_count + rest.rebil_count}`;
    },
  },
  {
    by: "free_reset_count",
    title: "Free resets",
    path: "free_reset_count",
    isSortable: true,
  },
];
